const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/user/$userId/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// Legacy User Profile Edit
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/user/$userId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Profile Edit",
      description: "Page title"
    })
  }
});